import React from "react";

const NimbusTable = ({
  columns = [
    {
      title: "Name",
      accessor: "name",
    },
    {
      title: "Age",
      accessor: "age",
    },
  ],
  data = [
    {
      name: "John Doe",
      age: 30,
    },
    {
      name: "Jane Smith",
      age: 25,
    },
  ],
}) => {
  if (data == null) {
    return <div>No data</div>;
  }
  return (
    <table className="w-full text-left">
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.accessor}>{column.title}</th>
          ))}
        </tr>
      </thead>
      <tbody className="">
        {data.map((row, rowIndex) => (
          <tr
            key={rowIndex}
            className="hover:bg-color-dark-background-tertiary"
          >
            {columns.map((column) => (
              <td>{row[column.accessor]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default NimbusTable;
